<template>
  <div v-if="!!value && !!value.length" style="max-width: 100%">
    <template v-for="(item, i) in value">
    <v-card
      v-if="!!item.images.length"
      :key="i"
      class="transparent mb-4"
      flat
    >
      <v-card-title class="text-center justify-center text-break">
        {{ item.name }}
      </v-card-title>

      <!-- حالت ۱: اسلایدر -->
      <swiper-wrapper
        v-if="isSlider && rerender"
        :imagesLength="item.images.length"
        autoplay
        wrapper-class="intro-slider"
        :direction="orientation"
      >
        <div
          v-for="(banner, index) in item.images"
          :key="index"
          class="swiper-slide"
        >
          <v-responsive :aspect-ratio="orientation === 'horizontal' ? 16 / 9 : 9 / 16">
            <v-card
              :style="{ backgroundImage: `url(${banner.url})` }"
              class="card-wrapper"
              flat
              height="100%"
              width="100%"
            />
          </v-responsive>
        </div>
      </swiper-wrapper>

      <!-- حالت ۲: شبکه‌ای (Grid) -->
      <v-row v-else-if="!isSlider" dense>
        <v-col
          v-for="(banner, index) in item.images"
          :key="index"
          :cols="orientation === 'horizontal' ? 12 : 6"
        >
          <v-responsive :aspect-ratio="orientation === 'horizontal' ? 16 / 9 : 9 / 16">
            <v-card
              :style="{ backgroundImage: `url(${banner.url})` }"
              class="card-wrapper rounded-lg"
              flat
              height="100%"
              width="100%"
            />
          </v-responsive>
        </v-col>
      </v-row>
    </v-card>
    </template>
  </div>
</template>

<script>
import SwiperWrapper from "../../pages/businessPage/components/cm/swiperWrapper";

export default {
  name: "imageSlider",

  components: { SwiperWrapper },

  props: {
    value: [Object, Array],
     orientation: {
    type: String,
    default:'horizontal' // 'vertical'
    
  },
  isSlider:{ type:Boolean,default:true}
  },

  data: () => ({
    rerender: true,
  }),

  created() {
    this.$root.$on("rerenderSwiper", this.rerenderSwiper);
  },

  watch: {
    value: {
      deep: true,

      handler(val) {
        this.rerenderSwiper();
      },
    },
     orientation() {
    this.rerenderSwiper();
  },
  },

  methods: {
    rerenderSwiper() {
      this.rerender = false;
      this.$nextTick(() => {
        this.rerender = true;
      });
    },
  },
};
</script>

<style scoped>
::v-deep .v-responsive__sizer ~ .v-responsive__content {
  margin-right: 0 !important;
  margin-left: 0 !important;
  width: 100%;
  min-width: 100%;
}
.card-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
}

.card-wrapper:not(.page-no-content):before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 1 !important;
  background-color: rgba(0, 0, 0, 0.56);
}

.swiper-slide-active >>> .page-content-wrapper {
  animation: anim-in ease-in;
  animation-delay: 1s;
  animation-fill-mode: both;
  animation-duration: 1s;
}

@keyframes anim-in {
  from {
    opacity: 0;
    transform: translateY(100%);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
}
</style>
